var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLista(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366 4464 c-255 -62 -415 -322 -351 -569 24 -89 72 -170 137 -231 64 -58 101 -80 188 -110 53 -18 124 -19 2225 -19 l2170 0 59 23 c88 33 135 64 193 124 58 62 96 132 118 215 65 248 -98 507 -356 568 -94 22 -4291 21 -4383 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 3015 c-122 -33 -238 -123 -295 -231 -145 -271 0 -601 299 -679 50 -13 333 -15 2203 -15 2350 0 2199 -4 2314 58 74 39 157 126 195 203 132 269 -15 588 -306 664 -84 22 -4329 21 -4410 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 1579 c-181 -23 -340 -169 -389 -354 -65 -252 102 -515 362 -570 102 -22 4264 -22 4366 0 260 55 427 318 362 570 -50 190 -207 330 -398 355 -88 11 -4215 11 -4303 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLista);
export default __webpack_public_path__ + "static/media/lista.e165dd4856e9a707aa07cf4a96863e35.svg";
export { ForwardRef as ReactComponent };